import { render } from "./ApplicationDetails.vue?vue&type=template&id=f90aa918"
import script from "./ApplicationDetails.vue?vue&type=script&lang=js"
export * from "./ApplicationDetails.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__